import { gql, useMutation } from '@apollo/client';

import { GET_PRODUCT_ADD_ONS } from './useProductAddOns';
import { useAddOnAppliesToOptions, useAddOnRequiredOnOptions } from '../../../views/addOns/hooks';

const UPDATE_PRODUCT_ADD_ON = gql`
  mutation updateProductAddOn($input: UpdateProductAddOnInput!) {
    updateProductAddOn(input: $input) {
      id
      label
      name
      cost
      appliesToAllPricingOptions
      pricingOptionIds
      requiredOnAllPricingOptions
      requiredForPricingOptionIds
    }
  }
`;

export default function useAddOnEdit({ addOn, toggle, selectOptions, productId, onError = () => {} }) {
  const [updateProductAddOn, { data, loading, error, reset }] = useMutation(UPDATE_PRODUCT_ADD_ON, {
    onCompleted: toggle,
    onError,
    refetchQueries: [{ query: GET_PRODUCT_ADD_ONS, variables: { id: productId } }]
  });

  const { addOnAppliesToOptions } = useAddOnAppliesToOptions();
  const { addOnRequiredOnOptions } = useAddOnRequiredOnOptions();

  const handleSubmit = ({
    cost,
    label,
    name,
    appliesToAllPricingOptions,
    pricings,
    requiredOnAllPricingOptions,
    requiredForPricings
  }) => {
    if (addOn?.id) {
      updateProductAddOn({
        variables: {
          input: {
            id: addOn?.id,
            label,
            name,
            cost: parseFloat(cost.replace('$', '')),
            appliesToAllPricingOptions: appliesToAllPricingOptions.value,
            pricingOptionIds: pricings?.map(pricing => pricing?.value),
            requiredOnAllPricingOptions: requiredOnAllPricingOptions.value,
            requiredForPricingOptionIds: requiredForPricings?.map(pricing => pricing?.value)
          }
        }
      });
    }
  };

  const initialValues = {
    name: addOn?.name || '',
    label: addOn?.label || '',
    cost: addOn?.cost || 0.0,
    appliesToAllPricingOptions: addOnAppliesToOptions.find(x => x.value === addOn?.appliesToAllPricingOptions),
    pricings: selectOptions?.filter(x => addOn?.pricingOptionIds?.includes(x.value)),
    requiredOnAllPricingOptions: addOnRequiredOnOptions.find(x => x.value === addOn?.requiredOnAllPricingOptions),
    requiredForPricings: selectOptions?.filter(x => addOn?.requiredForPricingOptionIds?.includes(x.value))
  };

  return {
    data,
    loading,
    error,
    reset,
    initialValues,
    handleSubmit
  };
}
